module.exports = __webpack_public_path__ + "static/media/logo2.ffec4a7f.png";